import React, { useEffect, useState } from "react";
import { AppIcon } from "./InstateamEmployeeComponents";

const LiveClockCard = ({
  width = "250px",
  height = "80px",
  bgColor = "#FFFFFF",
  iconBg = "#FFFFFF",
  borderRadius = "20px",
}) => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const formatted = now.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      setTime(formatted);
    };

    updateTime();

    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        width,
        height,
        background: bgColor,
        borderRadius,
        display: "flex",
        alignItems: "center",
        gap: "18px",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      {/* Icon Box */}
      <div
        style={{
          width: "72px",
          height: "72px",
          borderRadius: "22px",
          background: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <AppIcon name="clock" />
      </div>

      {/* Time Content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: 700,
            color: "#111",
            lineHeight: 1,
          }}
        >
          {time}
        </div>

        <div
          style={{
            marginTop: "8px",
            fontSize: "12px",
            color: "#666",
            fontWeight: 500,
          }}
        >
          Current Time
        </div>
      </div>
    </div>
  );
};

export default LiveClockCard;
